<template>
  <div class="w-full max-w-site-max-w">
    <ul class="grid">
      <timing-card />

      <named-card tag="li" class="row-span-2" :name="$t('voting_mechanic.title')">
        <paragraph small class="my-8">
          {{ $t('voting_mechanic.description') }}
        </paragraph>
        <radio-tiles
          :value="votingMechanic"
          name="votingMechanic"
          :options="votingOptions"
          class="justify-around"
          active-color="topics-teal"
          @input="updateVotingMechanic"
        >
          <template #tile="option">
            <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50" v-if="option.value === 'like'" v-bind:svg-inline="''" v-bind:src="'@/assets/images/voting/like.svg'" v-bind:class="'w-full h-full p-2'"><g fill="none" fill-rule="evenodd"><path fill="#FF7645" stroke="#FF7645" d="M46.242 14.568l-1.108-.277a4.06 4.06 0 00-4.838 2.656 1.096 1.096 0 01-2.102-.081l-.349-1.395A5.902 5.902 0 0032.12 11a6.083 6.083 0 00-5.857 4.437l-.422 1.5a1.065 1.065 0 01-2.047.01 3.892 3.892 0 00-4.653-2.693l-1.294.314a5.558 5.558 0 00-4.192 6.187l2.025 14.176c1.158 8.107 8.101 14.13 16.29 14.13 8.19 0 15.134-6.023 16.292-14.13l2.044-14.319a5.436 5.436 0 00-4.064-6.044z"/><g stroke="#00292B" stroke-linecap="round" stroke-width=".892"><path d="M31.703 23.892a.892.892 0 00-1.784 0h0m-5.353 0a.892.892 0 10-1.784 0h0"/><path fill="#00292B" stroke-linejoin="round" d="M23.674 26.568a3.569 3.569 0 007.137 0h-7.137z"/></g><g fill-rule="nonzero" transform="rotate(-4 26.818 5.182)"><path fill="#DDDBEA" d="M11.383 20.417h1.75v16.625a.875.875 0 11-1.75 0V20.417z"/><rect width="23.333" height="23.333" x=".279" y=".299" fill="#DDDBEA" stroke="#DDDBEA" stroke-linecap="round" stroke-width=".6" style="mix-blend-mode:multiply" stroke-linejoin="round" rx="9.333"/><rect width="23.333" height="23.333" x=".3" fill="#F7F7FF" rx="9.333"/><path fill="#4E4A6E" fill-opacity=".8" d="M9.96 15.162v-2.24h2.17v-2.1H9.96v-2.24H7.72v2.24H5.55v2.1h2.17v2.24h2.24zm8.568 1.358V7h-2.464L12.69 9.016l1.204 1.806 1.946-1.19v6.888h2.688z"/></g><path fill="#FF7645" fill-rule="nonzero" d="M13.837 28.33l-.51 5.827a.601.601 0 01-.651.547 3.527 3.527 0 01.614-7.026c.331.03.576.32.547.652z"/></g></svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="71" height="50" viewBox="0 0 71 50" v-else-if="option.value === 'one_and_two'" v-bind:svg-inline="''" v-bind:src="'@/assets/images/voting/one-and-two.svg'" v-bind:class="'w-full h-full p-2'"><g fill="none" fill-rule="evenodd"><path fill="#6284D6" fill-rule="nonzero" d="M21.966 1.5H25.8a6 6 0 016 6v3.6a2.4 2.4 0 004.8 0V7.5a6 6 0 016-6h3.834a4.8 4.8 0 014.794 4.56l1.92 38.4a4.8 4.8 0 01-4.794 5.04H20.046a4.8 4.8 0 01-4.794-5.04l1.92-38.4a4.8 4.8 0 014.794-4.56z"/><g transform="translate(30 18.3)"><path stroke="#00292B" stroke-linecap="round" stroke-linejoin="round" stroke-width=".9" d="M3.59 5.925a3.59 3.59 0 002.065.068 3.589 3.589 0 001.77-1.096"/><circle cx=".6" cy=".6" r="1" fill="#00292B" fill-rule="nonzero"/><circle cx="7.8" cy=".6" r="1" fill="#00292B" fill-rule="nonzero"/></g><path stroke="#DDDBEA" stroke-linecap="round" stroke-linejoin="round" stroke-width=".6" d="M17.1 49.641l34.5-.141"/><path fill="#6284D6" fill-rule="nonzero" d="M52.077 27.723l.564 6.446a.66.66 0 00.71.605c2.116-.185 3.678-2.074 3.49-4.22-.187-2.146-2.054-3.735-4.17-3.55a.66.66 0 00-.594.72zm-35.754 0l-.564 6.446a.66.66 0 01-.71.605c-2.116-.185-3.678-2.074-3.49-4.22.187-2.146 2.054-3.735 4.17-3.55a.66.66 0 01.594.72z"/><g fill-rule="nonzero" transform="rotate(10 22.198 277.276)"><path fill="#DDDBEA" d="M11.083 20.417h1.75v16.625a.875.875 0 11-1.75 0V20.417z"/><rect width="23.333" height="23.333" x=".052" y=".295" fill="#DDDBEA" stroke="#DDDBEA" stroke-linecap="round" stroke-width=".6" style="mix-blend-mode:multiply" stroke-linejoin="round" rx="9.333"/><rect width="23.333" height="23.333" fill="#F7F7FF" rx="9.333"/><path fill="#4E4A6E" fill-opacity=".8" d="M9.077 15.386v-2.24h2.17v-2.1h-2.17v-2.24h-2.24v2.24h-2.17v2.1h2.17v2.24h2.24zm9.59 1.358l.28-2.072h-3.682c3.01-2.576 3.486-3.584 3.486-4.886C18.75 8.302 17.575 7 15.223 7c-1.554 0-2.73.728-3.486 1.764l1.582 1.26c.504-.644.966-.952 1.596-.952.63 0 1.008.392 1.008 1.022 0 .966-.7 1.806-3.794 4.746v1.904h6.538z"/></g><g fill-rule="nonzero" transform="rotate(-4 25.636 -1.977)"><path fill="#DDDBEA" d="M11.383 20.417h1.75v16.625a.875.875 0 11-1.75 0V20.417z"/><rect width="23.333" height="23.333" x=".279" y=".299" fill="#DDDBEA" stroke="#DDDBEA" stroke-linecap="round" stroke-width=".6" style="mix-blend-mode:multiply" stroke-linejoin="round" rx="9.333"/><rect width="23.333" height="23.333" x=".3" fill="#F7F7FF" rx="9.333"/><path fill="#4E4A6E" fill-opacity=".8" d="M9.96 15.162v-2.24h2.17v-2.1H9.96v-2.24H7.72v2.24H5.55v2.1h2.17v2.24h2.24zm8.568 1.358V7h-2.464L12.69 9.016l1.204 1.806 1.946-1.19v6.888h2.688z"/></g></g></svg>
          </template>
        </radio-tiles>
      </named-card>

      <named-card tag="li" class="row-span-2" :name="$t('max_topics.title')">
        <checkbox-field
          v-model="enableMaxTopics"
          :label="$t('max_topics.toggle_label')"
          class="flex items-center my-6"
        />
        <number-field
          integer
          :model-value="maxTopics"
          :label="$t('max_topics.label')"
          :disabled="!enableMaxTopics"
          :min="0"
          @update:model-value="updateMaxTopics"
        />
        <paragraph small class="mt-8">
          {{ $t('max_topics.description') }}
        </paragraph>
      </named-card>

      <named-card tag="li" :name="$t('retro_name.name')">
        <name-card />
      </named-card>

      <named-card tag="li" :name="$t('call_link.title')">
        <call-link-card />
      </named-card>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

import CallLinkCard from '@/components/new/CallLinkCard.vue';
import componentI18n from '@/i18n/componentI18n';
import NameCard from '@/components/new/NameCard';
import NamedCard from '@/components/new/NamedCard';
import TimingCard from '@/components/new/TimingCard';

const MAX_TOPICS_DEFAULT = 5;

export default {
  name: 'AdvancedOptions',
  components: {
    CallLinkCard,
    NameCard,
    NamedCard,
    TimingCard
  },
  ...componentI18n('views.retro.new.advanced'),
  data() {
    return {
      enableMaxTopics: false
    };
  },
  computed: {
    ...mapGetters(['session']),
    ...mapState('newRetro', ['callLink', 'maxTopics', 'votingMechanic']),
    votingOptions() {
      return [
        {
          value: 'one_and_two',
          label: this.$t(`voting_mechanic.options.one_and_two.title`),
          description: this.$t(`voting_mechanic.options.one_and_two.description`)
        },
        {
          value: 'like',
          label: this.$t(`voting_mechanic.options.like.title`),
          description: this.$t(`voting_mechanic.options.like.description`)
        }
      ];
    }
  },
  watch: {
    enableMaxTopics() {
      let maxTopics = this.enableMaxTopics ? MAX_TOPICS_DEFAULT : null;
      this.updateMaxTopics(maxTopics);
    }
  },
  methods: {
    ...mapMutations('newRetro', ['updateMaxTopics', 'updateVotingMechanic'])
  }
};
</script>

<style lang="scss" scoped>
.grid {
  justify-content: center;
  display: grid;
  grid-auto-rows: minmax(10rem, auto);
  grid-template-columns: 1fr;
  grid-gap: 1.25rem;

  .row-span-2 {
    grid-row-end: span 2;
  }

  @media (min-width: 640px) {
    grid-template-columns: repeat(auto-fill, 20rem);
  }
}
</style>
